import { COUNTDOWN_SETTING } from './count-down';
import { COUNTER_SETTING } from './counter';
import { BREADCRUMBS_SETTING } from './breadcrumbs';

export const SETTING_BOOSTER = {
  'count-down': COUNTDOWN_SETTING,
  counter: COUNTER_SETTING,
  breadcrumbs: BREADCRUMBS_SETTING,
};
